import React from 'react';
import Seo from '../components/Seo';
import {
  BUSINESS_INFO,
  hasIncompleteLegalBusinessInfo,
  LEGAL_LAST_UPDATED_LABEL,
  LEGAL_TEXT_VERSION
} from '../lib/legal-config';
import { LEGAL_PAGE_SEO } from '../lib/seo';

const TECHNICAL_STORAGE_ITEMS = [
  {
    key: 'pp_cart_v1',
    scope: 'localStorage',
    purpose: 'Persistenza carrello shop',
    duration: 'fino a rimozione manuale'
  },
  {
    key: 'pp_checkout_pending_v1',
    scope: 'sessionStorage/localStorage',
    purpose: 'Gestione ritorno da Stripe checkout',
    duration: 'max 12 ore'
  },
  {
    key: 'pp_purchase_tracked_v1:*',
    scope: 'localStorage',
    purpose: 'Evita duplicazione evento acquisto analytics',
    duration: 'fino a rimozione manuale'
  },
  {
    key: 'pp_analytics_consent',
    scope: 'localStorage',
    purpose: 'Memorizzazione preferenze cookie analytics',
    duration: 'fino a modifica/revoca'
  },
  {
    key: 'pp_checkout_legal_acceptance_v1',
    scope: 'localStorage',
    purpose: 'Memorizzazione accettazione testi legali pre-checkout',
    duration: 'fino ad aggiornamento versione legale'
  },
  {
    key: 'panetteria_admin_api_token',
    scope: 'localStorage',
    purpose: 'Accesso area admin',
    duration: 'fino a logout/rimozione manuale'
  }
];

function LegalWarning() {
  if (!hasIncompleteLegalBusinessInfo()) {
    return null;
  }

  return (
    <p className="legal-warning">
      Attenzione: alcuni dati aziendali obbligatori sono placeholder e vanno completati prima del go-live.
    </p>
  );
}

const CookiePolicyPage = () => {
  return (
    <section className="legal-page">
      <Seo title={LEGAL_PAGE_SEO.cookie.title} description={LEGAL_PAGE_SEO.cookie.description} path="/cookie" />
      <h2 className="shop-title">Cookie Policy</h2>
      <p className="legal-meta">
        Versione: <strong>{LEGAL_TEXT_VERSION}</strong> | Ultimo aggiornamento: {LEGAL_LAST_UPDATED_LABEL}
      </p>
      <LegalWarning />

      <section className="legal-section">
        <h3>Impostazione base</h3>
        <p>
          Il sito usa di default soli strumenti tecnici necessari al funzionamento. Gli analytics vengono attivati solo
          dopo consenso esplicito.
        </p>
      </section>

      <section className="legal-section">
        <h3>Tecnologie tecniche utilizzate</h3>
        <div className="legal-table-wrap">
          <table className="legal-table">
            <thead>
              <tr>
                <th>Chiave</th>
                <th>Storage</th>
                <th>Finalita&apos;</th>
                <th>Durata</th>
              </tr>
            </thead>
            <tbody>
              {TECHNICAL_STORAGE_ITEMS.map((item) => (
                <tr key={item.key}>
                  <td>{item.key}</td>
                  <td>{item.scope}</td>
                  <td>{item.purpose}</td>
                  <td>{item.duration}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section className="legal-section">
        <h3>Analytics</h3>
        <p>
          In caso di consenso analytics, il sito carica Google Analytics 4 (GA4) con configurazione orientata alla sola
          misurazione del traffico del sito e degli eventi principali di shop e checkout.
        </p>
      </section>

      <section className="legal-section">
        <h3>Come revocare il consenso</h3>
        <p>
          Puoi modificare la preferenza cookie in qualsiasi momento dal link &quot;Preferenze cookie&quot; nel footer.
          Per richieste privacy contatta {BUSINESS_INFO.dataControllerEmail}.
        </p>
      </section>
    </section>
  );
};

export default CookiePolicyPage;
